import { NodeModel } from '@minoru/react-dnd-treeview'
import { createReducer } from '@reduxjs/toolkit'
import { NodeDataT } from 'shared/types'
import { receiveFileTree } from 'src/model/actions'

const initialState = {} as Partial<Record<string, NodeModel<NodeDataT>[]>>

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveFileTree, (state, action) => action.payload)
})

export default reducer
